import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { api } from '@/utils/constants'

import { PayloadOrder } from '@/types/operations/order'

export const createOrder = http.post(
    `${process.env.REACT_APP_API_ADDRESS}/${api.operations.orders.LIST}`,
    async ({ request }) => {
        const payload = await request.json()
        const payloadParsed = PayloadOrder.safeParse(payload)

        // Wrong payload
        if (!payloadParsed.success) {
            return HttpResponse.json(payloadParsed.error.issues, {
                status: StatusCodes.UNPROCESSABLE_ENTITY,
            })
        }

        return HttpResponse.json<PayloadOrder>(payloadParsed.data, {
            status: StatusCodes.CREATED,
        })
    },
)
